<template>
  <div>
    <ca-row>
      <ca-col size="2">
        <ca-button full-width @click="onEdit">Editar</ca-button>
      </ca-col>
      <ca-col size="2">
        <ca-button
          full-width
          @click="onDelete">
          Excluir
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :on-fetch="getStock"
            :on-fetch-success="setStock">
            <div v-if="stock">
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Código">
                    {{ stock.allocationCode }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Código FPAS">
                    {{ stock.fpasCode }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Código de Terceiros">
                    {{ stock.thirdPartyCode }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row vertical-offset="2">
                <ca-col size="8">
                  <ca-field label="Tipo de Lotação">
                    {{ stock.allocationType.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Situação no eSocial">
                    {{ stock.statusEsocial.description }}
                  </ca-field>
                </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { getErrorMessageFromResponse } from 'packages/common/utils';
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import { getStock, deleteStock } from './stockingService';

export default {
  name: 'StockingsViewPage',
  data() {
    return {
      stock: null,
      stockId: this.$route.params.id,
    };
  },
  methods: {
    getStock() {
      return getStock(this.stockId);
    },
    setStock(stock) {
      this.stock = stock;
    },
    onEdit() {
      this.$router.push({ name: 'EditStock', params: { id: this.stockId } });
    },
    onDelete() {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteStock(this.stockId)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.$router.back();
            })
            .catch(e => {
              this.$toaster.error(getErrorMessageFromResponse(e));
            });
        },
      });
    },
  },
};
</script>
